// FCR Scale Table - maps average live weight (kg) to target FCR values
export const FCR_SCALE_TABLE: [number, number][] = [
  [1.900, 1.570],
  [1.925, 1.575],
  [1.950, 1.580],
  [1.975, 1.585],
  [2.000, 1.590],
  [2.025, 1.595],
  [2.050, 1.600],
  [2.075, 1.605],
  [2.100, 1.610],
  [2.125, 1.615],
  [2.150, 1.620],
  [2.175, 1.625],
  [2.200, 1.630],
  [2.225, 1.635],
  [2.250, 1.640],
  [2.275, 1.650],
  [2.300, 1.655],
  [2.325, 1.660],
  [2.350, 1.665],
  [2.375, 1.670],
  [2.400, 1.675],
  [2.425, 1.680],
  [2.450, 1.685],
  [2.475, 1.690],
  [2.500, 1.695],
  [2.525, 1.700],
  [2.550, 1.705],
  [2.575, 1.710],
  [2.600, 1.715],
  [2.625, 1.720],
  [2.650, 1.725],
  [2.675, 1.730],
  [2.700, 1.735],
  [2.725, 1.740],
  [2.750, 1.750],
  [2.775, 1.755],
  [2.800, 1.760],
  [2.825, 1.765],
  [2.850, 1.770],
  [2.875, 1.775],
  [2.900, 1.780],
  [2.925, 1.785],
  [2.950, 1.790],
  [2.975, 1.795],
  [3.000, 1.800],
  [3.025, 1.805],
  [3.050, 1.810],
  [3.075, 1.815],
  [3.100, 1.820],
  [3.125, 1.825],
];

// Default pricing parameters
export const DEFAULT_PRICING: Record<string, number> = {
  meatPricePerKg: 0,
  feedBonusRate: 9.0,
  feedPenaltyRate: 14.0,
  epefLimit1: 331,
  epefLimit2: 350,
  epefLimit3: 370,
  epefPrice1: 0.10,
  epefPrice2: 0.15,
  epefPrice3: 0.20,
  chickBonusRate: 0.50,
  chickPenaltyRate: 2.00,
  mortalityLimit: 5.0,
  coalSupportRate: 50,
};
